<template>
<div class="chapter">
<div class="inner_page">
<p class="dedicationtt"><a id="page_v"></a>Dwight:</p>
<p class="dedication">To our ancestors in both American navies of the Civil War. With courage, dedication, and honor, they struggled and sacrificed for their respective causes—one noble and the other tragically wrong—in the best traditions of the United States Navy that was their heritage.</p>
<p class="dedication">On the cusp of revolution from ancient wood, wind, canvas, and smoothbore to iron, steel, mechanical propulsion, and big guns, they laid the foundation for the modern sea service.</p>
<p class="dedication">May they rest in peace and may men and women of today’s navy continue to learn from their triumphs and their mistakes.</p>
<p class="dedicationt">Chris:</p>
<p class="dedication">For John Tulley and Richard Close</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?dfb4ec4e